import {Component, Injector, OnInit, ViewChild} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {JwtHelperService} from "@auth0/angular-jwt";
import {UserService} from "../dashboard/services/user.service";
import {BasePageComponentDirective} from "../../_shared/base/base-page.component";
import {MatTabGroup} from "@angular/material/tabs";
import {ParameterService} from "../../_services/parameter.service";

@Component({
  selector: 'email-agent',
  templateUrl: './email-agent.component.html',
  styleUrls: ['./email-agent.component.scss']
})
export class EmailAgentComponent extends BasePageComponentDirective<any> implements OnInit {

  @ViewChild('tabGroup', { static: false }) tabGroup!: MatTabGroup;
  form: FormGroup;
  messages: any[] = [];
  fileUrl: string | ArrayBuffer;
  fd: FormData;
  uploading = false;
  hasAttachment = false;
  ticketStatus: any = {};
  constructor(
    injector: Injector,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private jwtHelper: JwtHelperService,
    private parameterService: ParameterService,
  ) {
    super(injector);
    this.form = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      subject: ['', Validators.required],
      msg: ['', Validators.required]
    });

  }

  override async ngOnInit(): Promise<void> {
    super.ngOnInit();
    const isLoggedIn = !this.jwtHelper.isTokenExpired();
    if (isLoggedIn) {
      this.profileMsg.currentMessage.subscribe(async r => {
        if(r) {
          const user = r;
          this.ticketStatus = await this.parameterService.getParameterByName("TICKET_STATUS");
          this.form.controls.name.setValue(user.fullName);
          this.form.controls.email.setValue(user.email);
          this.query();
        }
      })
    }
  }

  getFileChange($event: FileList): void {
    this.fd = new FormData();
    const fileTransfer = $event[0];
    this.fd.append('file', fileTransfer);
  }

  goToNewTicket() {
    this.tabGroup.selectedIndex = 1;
  }
  resetForm() {
    this.form.reset();
    this.form.reset();
    this.form.markAsPristine();
    this.form.markAsUntouched();
  }

  save() {
    const validation = this.check(this.form);
    if(validation) {
      this.showAlert('Warning', 'Please fill all required input', 'You cannot send empty message and minimum message length is 5 characters');
      return;
    }
    this.form.disable();
    this.uploading = true;
    this.userService.openWalletSupportTicket(
        this.form.controls.name.value,
        this.form.controls.email.value,
        this.form.controls.subject.value,
        this.form.controls.msg.value
    ).then(r => {
      if(this.hasAttachment) {
        this.userService.uploadFileAttachment(this.fd, r.id).then(_ => {
          this.tabGroup.selectedIndex = 0;
          this.form.reset();
          this.form.markAsPristine();
          this.form.markAsUntouched();
          this.fd = new FormData();
          this.snackBar.open('Ticket has been created successfully!', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
          this.uploading = false;
          this.form.enable();
          this.query();
        });
      } else {
        this.tabGroup.selectedIndex = 0;
        this.form.reset();
        this.form.markAsPristine();
        this.form.markAsUntouched();
        this.uploading = false;
        this.form.enable();
        this.snackBar.open('Ticket has been created successfully!', null, {duration: 3000, verticalPosition: 'top', horizontalPosition: 'right'});
        this.query();
      }

    });
  }

  conversation(id: number) {
    this.router.navigate(['/wallet-support/' + id + '/conversation']).then();
  }

  query(): void {
    this.pageQuery.sortBy = 'id';
    this.pageQuery.sortOrder = 'desc';

    this.pageQuery.columns = ['subject', 'status', 'id'];
    this.userService.getWalletSupport(this.pageQuery).then(r => {
      this.messages = r.content;
      this.page.emit(r);
    });
  }
}
